<template>
  <v-container fluid>
    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
    <v-card class="card--flex-toolbar">
      <v-toolbar color="grey lighten-4" class="elevation-0" tabs>
        <v-toolbar-title>Habilitar Fornecedores</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-tabs-items v-model="active" style="min-height:350px">
          <v-tab-item key="1">
            <!-- BLOQUEIO ATIVIDADE -->
            <v-layout column style="height: 320px">
              <v-flex style="overflow: auto">
                <v-data-table
                  v-model="fornecedor"
                  :headers="headersFornecedor"
                  :items="fornecedorItens"
                  item-key="programa"
                  :rows-per-page-items="[1000]"
                  hide-actions
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.nome }}</td>
                    <td width="20px">
                      <v-checkbox v-model="props.item.acessar" primary hide-details></v-checkbox>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="salvar()">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import { showFlash, showError } from '@/utils'
import fornecedorService from '@/services/fornecedor'
import empresafornecedorService from '@/services/empresa_fornecedor'

export default {
  name: 'associados',
  data () {
    return {
      search: '',
      fornecedor: [],
      fornecedorItens: [],
      user: '',
      headersFornecedor: [
        {
          text: 'Fornecedor',
          align: 'left',
          sortable: false,
          value: 'nome'
        }, {
          text: 'Habilitar',
          align: 'center',
          sortable: false,
          value: 'acessar'
        }],
      loading: false,
      valid: true,
      active: 0,
      modo: '',
      usuario: '',
      resultado: {}
    }
  },
  mounted: async function () {
    try {
      this.loading = true
      let result = await fornecedorService.getTudo()
      if (result.data === undefined) {
        return
      }
      var passo
      for (passo = 0; passo <= result.data.length - 1; passo++) {
        this.fornecedorItens.push(result.data[passo])
      // this.fornecedor = result.data[passo]
      }
    } catch (error) {
      showError(error)
    } finally {
      this.loading = false
    }
  },
  methods: {
    async salvar () {
      try {
        let perm = []
        this.fornecedorItens.forEach(item => {
          perm.push(
            {
              id: item.id,
              programa: item.nome,
              acessar: item.acessar
            })
        })
        if (perm.length > 0) {
          await empresafornecedorService.save(perm)
        }
        showFlash('Salvo com sucesso')
      } catch (error) {
        showError(error)
      }
    }
  }
}
</script>
